import { render, staticRenderFns } from "./cousult.vue?vue&type=template&id=592c7c2d&scoped=true&"
import script from "./cousult.vue?vue&type=script&lang=js&"
export * from "./cousult.vue?vue&type=script&lang=js&"
import style0 from "./cousult.vue?vue&type=style&index=0&id=592c7c2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592c7c2d",
  null
  
)

export default component.exports